// ABOUTME: Sidebar navigation data - groups of items with paths, labels, and icons
// ABOUTME: Pure data; Sidebar.tsx renders from this

import type { ReactNode } from 'react';
import {
  AlphaPicksIcon,
  BarsIcon,
  BookOpenIcon,
  CheckIcon,
  DashboardIcon,
  DiscoveryIcon,
  DocumentIcon,
  ModelAdminIcon,
  PortfolioIcon,
  PublishedAdminIcon,
  RealTimeIcon,
  RiskIcon,
  SearchIcon,
  SettingsCogIcon,
  TradeQueueIcon,
  WatchlistIcon,
} from './sidebar-icons';

export interface NavItem {
  path: string;
  label: string;
  icon: ReactNode;
  // Extra path prefixes that also highlight this item — used by hub entries whose
  // tabs live at scattered routes (e.g. Risk owns /correlation, /factors, …).
  match?: string[];
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

export const navGroups: NavGroup[] = [
  {
    title: 'Overview',
    items: [
      { path: '/', label: 'Dashboard', icon: <DashboardIcon /> },
      {
        path: '/scanner',
        label: 'Discover',
        icon: <DiscoveryIcon />,
        match: ['/scanner', '/picks', '/entry-leaderboard', '/discovery'],
      },
      {
        path: '/trade-queue',
        label: 'Trade',
        icon: <TradeQueueIcon />,
        match: ['/trade-queue', '/entry-positions'],
      },
      {
        path: '/portfolios',
        label: 'Portfolios',
        icon: <PortfolioIcon />,
        match: ['/portfolios', '/portfolio'],
      },
      {
        path: '/watchlists',
        label: 'Watchlists',
        icon: <WatchlistIcon />,
        match: ['/watchlists', '/watchlist'],
      },
    ],
  },
  {
    title: 'Analysis',
    items: [
      {
        path: '/risk/portfolio',
        label: 'Risk',
        icon: <RiskIcon />,
        match: ['/risk', '/risk-decomposition', '/correlation', '/factors'],
      },
      {
        path: '/portfolio-optimization',
        label: 'Strategy',
        icon: <SettingsCogIcon />,
        match: ['/portfolio-optimization', '/backtesting', '/options'],
      },
      {
        path: '/real-time',
        label: 'Market',
        icon: <RealTimeIcon />,
        match: ['/real-time', '/fundamentals', '/sentiment'],
      },
      { path: '/forecast', label: 'Forecast', icon: <AlphaPicksIcon />, match: ['/forecast'] },
    ],
  },
  {
    title: 'Admin',
    items: [
      { path: '/models', label: 'Models', icon: <ModelAdminIcon /> },
      { path: '/admin/published', label: 'Published Lists', icon: <PublishedAdminIcon /> },
      { path: '/inference', label: 'Inference', icon: <ModelAdminIcon /> },
      { path: '/symbols', label: 'Symbols', icon: <SearchIcon /> },
      { path: '/monitoring', label: 'Monitoring', icon: <BarsIcon /> },
      { path: '/validation', label: 'Validation', icon: <CheckIcon /> },
    ],
  },
];

// Help links — rendered as a compact affordance at the bottom of the sidebar,
// out of the primary navigation.
export const helpItems: NavItem[] = [
  { path: '/guide', label: 'Guide', icon: <DocumentIcon /> },
  { path: '/tutorial', label: 'Tutorial', icon: <BookOpenIcon /> },
  { path: '/api-docs', label: 'API Docs', icon: <DocumentIcon /> },
];
